import { useContext } from 'react';

import { DirectRequestDialogContext } from '@/context/directRequestDialogContext';

export function useDirectRequestDialogContext() {
  return useContext(DirectRequestDialogContext);
}
